var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157340"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2123",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18 12C18 15.3137 15.3137 18 12 18M18 12C18 8.68629 15.3137 6 12 6M18 12C18 13.1046 15.3137 14 12 14C8.68629 14 6 13.1046 6 12M18 12C18 10.8954 15.3137 10 12 10C8.68629 10 6 10.8954 6 12M12 18C8.68629 18 6 15.3137 6 12M12 18C10.8954 18 10 15.3137 10 12C10 8.68629 10.8954 6 12 6M12 18C13.1046 18 14 15.3137 14 12C14 8.68629 13.1046 6 12 6M6 12C6 8.68629 8.68629 6 12 6",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.e2ba05000c2013fee472a234cd7c9d0e.svg";
export { ForwardRef as ReactComponent };